import styled from 'styled-components';
import { FlexColumn, Text } from '@make-software/tg-mini-app-ui';

export const processModalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 9999
  }
};

export const Content = styled(FlexColumn)<{ isTransactionProcessing?: boolean }>(
  ({ theme, isTransactionProcessing }) =>
    theme.withMedia({
      marginTop: isTransactionProcessing ? 0 : 24
    })
);

export const AnimationContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    marginTop: '-20px'
  })
);

export const StyledBodyText = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily.sans,
  lineHeight: '21px'
}));

export const StyledBodyTextMono = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily.display,
  lineHeight: '21px'
}));

export const Title = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '-0.36px',
    lineHeight: '140%',
    marginTop: '25px',
    fontFamily: 'Inter'
  })
);

export const Description = styled(Text)<{ isTransactionProcessing?: boolean }>(
  ({ theme, isTransactionProcessing }) =>
    theme.withMedia({
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '140%',
      marginTop: 10,
      marginBottom: isTransactionProcessing ? 0 : 24,
      textAlign: 'center',
      color: '#A9AAAD',
      fontFamily: 'Inter'
    })
);
